import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';

export const RiskAnalysisCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    margin: ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.giga} 0;
    padding: 0 ${theme.layout.spacing.centy} ${theme.layout.spacing.centy};
  `}
`;

interface IRiskSliderCont {
  height?: string;
  theme: ITheme;
}

export const RiskSliderCont = styled.div<IRiskSliderCont>`
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ theme, height }: IRiskSliderCont) => `
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
    height: ${height ? height : '320px'};
  `}
`;
